import React from 'react';
import { Navigate } from 'react-router-dom';

import { ORDERS_ROUTE } from '@/routes';

export const NotFoundPage: React.FC = () => {
  return <Navigate to={ORDERS_ROUTE} />;
};
